// @ady/i18n: the string layer (D-013). A single `en` locale today, externalised so a language could
// be added later without a rewrite. Owner: P4-B (T4-08, SETTINGS-001).
import { en, type EnCatalogue } from "./en";
import {
  createTranslator,
  type EntryAt,
  type KeyOf,
  type ParamsOf,
  type Translator,
} from "./translator";

export * from "./translator";
export { en, type EnCatalogue };

/** Every key in the English catalogue. */
export type MessageKey = KeyOf<EnCatalogue>;
export type EnTranslator = Translator<EnCatalogue>;

/** Keys whose string has no placeholders: safe to store in data (nav labels) and pass to t(). */
export type PlainKey = {
  [K in MessageKey]: [ParamsOf<EntryAt<EnCatalogue, K>>] extends [never] ? K : never;
}[MessageKey];

/** The default translator. `lang` on <html> stays "en" (DESIGN_SYSTEM §10.3). */
export const i18n: EnTranslator = createTranslator(en, "en");
export const t: EnTranslator["t"] = i18n.t.bind(i18n);
